module.exports = __webpack_public_path__ + "img/14.785fd205.png";